import { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
/**
 *
 *
 *  ?  Auth
 *
 *
 */
import Auth from "@pages/Auth";
import Header from "@components/Header";
import Navigation from "@components/Navigation";
import Footer from "@components/Footer";
import HomeIndex from "@pages/home/HomeIndex";
/**
 *
 *
 *  ?  Home pages
 *
 *
 */
import Resultados from "@pages/home/Resultados";
import ResultadosZero from "@pages/home/ResultadosZero";
import DetallesProducto from "@pages/home/DetallesProducto";
import AgregadoCarrito from "@pages/home/AgregadoCarrito";
import Carrito from "@pages/home/Carrito";
/**
 *
 *
 *  ?  Checkout
 *
 *
 */
import ComprarComoInvitado from "@pages/checkout/ComprarComoInvitado";
import DireccionEnvio from "@pages/checkout/DireccionEnvio";
import ResumenPedido from "@pages/checkout/ResumenPedido";
import InformacionPago from "@pages/checkout/InformacionPago";
import CompraExitosa from "@pages/checkout/CompraExitosa";
/**
 *
 *
 *  ?  Perfil
 *
 *
 */
import WishList from "@pages/perfil/WishList";
import MisPedidos from "@pages/perfil/MisPedidos";
import MiPerfil from "@pages/perfil/MiPerfil";
import MisBeneficios from "@pages/perfil/MisBeneficios";
/**
 *
 *
 *  ?  Static
 *
 *
 */
import SobreNosotros from "@pages/static/SobreNosotros";
import TermsConds from "@pages/static/TermsConds";
import PrivacyPolicy from "@pages/static/PrivacyPolicy";
import ReturnsandExchanges from "@pages/static/ReturnsandExchanges";
import TablaTallas from "@pages/static/TablaTallas";
import Contacto from "@pages/static/Contacto";
import Error404 from "@pages/static/Error404";
import ListaSubcategorias from "@pages/home/ListaSubcategorias";
import ResultadosSubcategorias from "@pages/home/ResultadosSubcategorias";
import NuestrosArtistas from "@pages/home/NuestrosArtistas";
import ResultadosArtistas from "@pages/home/ResultadosArtistas";
import { RedirectLogin, RedirectPanel } from "@components/ProtectedRoute";
import EditarMisDatos from "@pages/perfil/EditarMisDatos";
import AgregarEditarDireccionEnvio from "@pages/perfil/AgregarEditarDireccionEnvio";
import RegistroExitoso from "@pages/auth/RegistroExitoso";
import { CartProvider } from "@context/CardContext";
import { AuthProvider } from "@context/AuthContext";
import TermsService from "@pages/static/TermsService";
import Envios from "@pages/static/Envios";
import Cookies from "@pages/static/Cookies";
import CompraPendiente from "@pages/checkout/CompraPendiente";
import OldYear from "@components/OldYear";
import NotOfLegalAge from "@pages/static/NotOfLegalAge";
import { AuthPopup } from "@pages/Auth";
import { UrlAuthProvider } from "@context/UrlAuthProvider";

export default function AppRoutes() {
  const location = useLocation().pathname;
  const isWlcmLogin = /^\/login/.test(location) || /^\/cambiar-contrasena/.test(location);
  const isCheckout = /^\/checkout/.test(location);
  /**
   *
   * ? Header Bubble -> <Header wishlist='3' />
   *
   * ! Checkout header and footer only
   *
   *
   */
  const [showOldYear, setShowOldYear] = useState(true);

  useEffect(() => {
    const currentPath = window.location.pathname;
    setShowOldYear(
      !currentPath.includes('terminos') &&
      !currentPath.includes('privacidad') &&
      !currentPath.includes('devoluciones') &&
      !currentPath.includes('mayor')
    );
  }, [location]);

  return (
    <>

        <UrlAuthProvider>

          <AuthProvider>

            {!isWlcmLogin && !isCheckout && <Header />}
            {!isWlcmLogin && !isCheckout && <Navigation />}

            <OldYear />
            
            <AuthPopup />

            <Routes>

              {/* REDIRIGE AL  SI HAY UN USUARIO LOGUEADO */}
              <Route element={<RedirectPanel />}>

                <Route path="/login" element={<Auth page="IniciarSesionWith" />} />
                <Route path="/login-crear" element={<Auth page="CrearCuenta" />} />
                <Route path="/login-recuperar" element={<Auth page="RestablecerPassword" />} />
                <Route path="/login-email" element={<Auth page="Login" />} />
                <Route path="/login-exito" element={<Auth page="RegistroExitoso" />} />

              </Route>

              <Route path="/cambiar-contrasena/:token" element={<Auth page="CambiarPassword" />} />
              <Route path="/cambiar-contrasena-exito" element={<Auth page="CambiadoPassword" />} />
              <Route path="/login-confirmar-registro" element={<Auth page="ConfirmarRegistro" />} />
              <Route path="/login-confirmar-recuperar" element={<Auth page="ConfirmarCorreoRecuperar" />} />

              {/* PARA ACCEDER DEBE DE EXISTIR UN UNSUARIO LOGUEADO */}
              <Route element={<RedirectLogin />}>

                <Route path="/wishlist" element={<WishList />} />
                <Route path="/mis-pedidos" element={<MisPedidos />} />
                <Route path="/mi-perfil" element={<MiPerfil />} />
                <Route path="/mi-perfil/editar-datos" element={<EditarMisDatos />} />
                <Route path="/mi-perfil/agregar-direccion" element={<AgregarEditarDireccionEnvio />} />
                <Route path="/mi-perfil/editar-direccion/:idDireccion" element={<AgregarEditarDireccionEnvio />} />
                <Route path="/mi-perfil/mis-beneficios" element={<MisBeneficios />} />

              </Route>

              {/* RUTAS DE CARRO Y CHECKOUT */}
              <Route path="/carrito" element={<Carrito />} />
              <Route path="/checkout-guest" element={<ComprarComoInvitado />} />
              <Route path="/checkout-envio" element={<DireccionEnvio />} />
              <Route path="/checkout-resumen" element={<ResumenPedido />} />
              <Route path="/checkout-pago" element={<InformacionPago />} />
              <Route path="/checkout-exito" element={<CompraExitosa />} />
              <Route path="/checkout-pendiente" element={<CompraPendiente />} />
              <Route path="/paypal/return" element={<CompraExitosa />} />
              <Route path="/paypal/cancel" element={<InformacionPago />} />
              <Route path="/agregado-carrito" element={<AgregadoCarrito />} />

              {/* RUTAS PUBLICAS */}
              <Route path="/" element={<HomeIndex />} />
              <Route path="/home" element={<HomeIndex />} />
              <Route path="/terminos-y-condiciones" element={<TermsConds />} />
              <Route path="/terminos-de-servicios" element={<TermsService />} />
              <Route path="/terminos-de-privacidad" element={<PrivacyPolicy />} />
              <Route path="/cambios-y-devoluciones" element={<ReturnsandExchanges />} />
              <Route path="/no-mayor-de-eddad" element={<NotOfLegalAge />} />
              <Route path="/envios" element={<Envios />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/about" element={<SobreNosotros />} />
              <Route path="/tabla-de-tallas" element={<TablaTallas />} />
              <Route path="/resultados/:search" element={<Resultados title="Estos artículos coinciden con tu búsqueda" databc={["T-Shirts"]} />} />
              <Route path="/sin-resultados" element={<ResultadosZero databc={["T-Shirts"]} />} />
              <Route path="/404" element={<Error404 />} />

              {/* Detalle de Productos */}
              <Route path="/detalles-producto/:uri" element={<DetallesProducto />} />

              {/* CATEGORIAS Y SUBCATEGORIAS */}
              <Route path="/nuestros-artistas" element={<NuestrosArtistas />} />
              <Route path="/nuestros-artistas/:uri" element={<ResultadosArtistas />} />
              <Route path="/our-artists" element={<NuestrosArtistas />} />
              <Route path="/our-artists/:uri" element={<ResultadosArtistas />} />
              
              <Route path="/category/:categoria" element={<ListaSubcategorias />} />
              <Route path="/category/:categoria/:subcategoria" element={<ResultadosSubcategorias />} />

              {/* COLECCIONES */}
              <Route path="/contacto" element={<Contacto />} />

              {/* CONFIRMACION DE CUENTA */}
              <Route path="/registro-exitoso/:token" element={<RegistroExitoso />} />


            </Routes>

          </AuthProvider>

        </UrlAuthProvider>

      {!isWlcmLogin && <Footer />}

    </>
  );
}
